module.exports = __webpack_public_path__ + "src/assets/individualImages/sweatBee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/sweatBee.png
// module id = ./src/assets/individualImages/sweatBee.png
// module chunks = 0